<template>
  <div class="tusd-wrap wrap-bg">
    <div class="page-title"><i class="back-btn" @click="goBack"></i>账户明细</div>
    <div class="records-title clearfix">
    	<span class="records-time">时间</span>
    	<span class="records-type">类型</span>
    	<span class="records-amount">金额</span>
    </div>
    <div class="separator"></div>
	<div class="order-scroll">
		<cube-scroll ref="scroll" :data="records" :options="scrollOptions" @pulling-down="refreshData"  @pulling-up="loadMoreData">
				<div class="records-list">
					<div class="records-item clearfix" v-for="(r,index) in records" :key="index" @click="goDetails(r.StreamId,r.StreamType)">
						<span class="records-time">{{r.DateStr}}</span>
						<span class="records-type" :class="{out:r.StreamType==2}">{{r.StreamTypeName}}</span>
						<span class="records-amount">{{r.StreamMoney}}<i class="details-btn"></i></span>
					</div>
					<div class="records-noData" v-if="records.length < 1">暂无账户明细</div>
				</div>
		</cube-scroll>
	</div>
  
  </div>
</template>

<script>
export default {
  name: 'records',
  data(){
  	return {
  		records:[],
  		page:1,
  		scrollOptions:this.$store.state.refreshOptions,
  		params:{}
  	}
  },
  methods:{
  	goBack(){
  		this.$router.push({name:this.params.back})
  	},
  	goDetails(id,ordertype){
  		let name = 'recordDetails'
  		this.$store.commit('storeParams',{
  			name:name,
  			back:'records',
  			orderinfo:{orderid:id,type:ordertype}
  		})
  		this.$router.push({name:name})
  	},
  	getRecords(){
		let that = this;
		let data = { pageIndex: that.page, pageSize: 10 };
		that.$api.getCoinUpList(data).then(res => {
			let data = res.data;
			if (data.TotalPages< that.page) {
				that.$refs["scroll"].forceUpdate();
				return;
			}
        that.records = that.records.concat(data.Items);
        that.page++;
      });
  	},
  	refreshData(){
  		this.getRecords()
  	},
  	loadMoreData(){
  		this.getRecords()
  	}
  },
  created(){
  	this.params = this.$store.state.routerStore.records
  	this.refreshData()
  }
}
</script>

<style lang="less" scoped>

	.order-scroll{
		height: calc(100% - 150px);
	}
	.records-title,
	.records-item{
		line-height: @item-height;
		color:#575f8d;
		text-align: center;
	}
	.records-time{
		float: left;
		width: 40%;
	}
	.records-type{
		float: left;
		width: 23%;
	}
	.records-amount{
		float: left;
		width: 36%;
	}
	.records-list{
		.records-item{
			border-bottom:1px solid #3c4468;
			.records-time{
				color:#8092c6;
			}
			.records-type{
				color:#569eff;
				&.out{
					color:#f08da1;
				}
			}
			.records-amount{
				position: relative;
				color:#d9e3fd;
				    padding-right: 35px;
    text-align: right;
				.details-btn{
					position: absolute;
					top:17px;
					right:12px;
					width: 16px;
					height: 16px;
					margin-left: 14px;
					background: url(../assets/images/more.svg) center center no-repeat;
				}
			}
		}
		.records-noData{
			padding:20px 0px;
			text-align: center;
			color:#d9e3fd;
		}
	}
</style>